import React from 'react'

function Header() {
  return (
    <div className="w-full text-center py-3 bg-blue text-[color:white] font-serif font-semibold">
        <h1>Top Course's</h1>
    </div>
  )
}

export default Header